import { h} from 'preact';
import { useState } from 'preact/hooks';
import Markup from 'preact-markup';
import { Text, MarkupText } from 'preact-i18n';
import Carousel from 'preact-flickity-component'
import '../../../node_modules/flickity/dist/flickity.css'


export const OnePlaceCard = props => {
  const [placeBlock, setPlaceBlock] = useState(props.placeBlock);
  if(!placeBlock || !placeBlock.name || !placeBlock.url) {
    return ("");
  }
  let address = placeBlock.address.neighborhood ? (placeBlock.address.neighborhood + ", " + placeBlock.address.addressLocality + " " + placeBlock.address.addressRegion ) : "";
  return (
    <div className="ae-border-box">
      <div className="place-card">
        <a className="ae-dark" href={placeBlock.url} target="_blank">
          <div className="ae-subtitle-large place-title"><Markup className="ae-ellipsis-1" markup={placeBlock.name} type="html" trim={false}/></div>
          <div className="ae-para ae-ellipsis-1">
            {address ? address + " • " : ""}
            {placeBlock.telephone ? placeBlock.telephone + " • " : ""}
            {placeBlock.url ? new URL(placeBlock.url).host : ""}
          </div>
        </a>
      </div>
    </div>
  )
}
export const Place = props =>  {
  const [item, setItem] = useState(props.item);
  const [searchResp, setSearchResp] = useState(props.searchResp);
  const [query, setQuery] = useState(props.query);
  const [section, setSection] = useState(props.section);
  if(!item || isNaN(item.resultIndex) || item.answerType !== "Places") {
    return (""); //defensive check
  }
  let placeBlock = searchResp.places.value[item.resultIndex];

  return (<OnePlaceCard placeBlock={placeBlock} />);
}

export const PlacesCarousel = props =>  {
  const [items, setItems] = useState(props.items);
  const [searchResp, setSearchResp] = useState(props.searchResp);
  const [query, setQuery] = useState(props.query);
  const [section, setSection] = useState(props.section);

  if(!items || items.length <= 0 || items[0].answerType != "Places") {
    return "";
  }
  //make sure it has real places
  let hasPlace = false;
  for(var ix in items) {
    let item = items[ix];
    if(item.answerType==="Places" && !isNaN(item.resultIndex)) {
      let placeBlock = searchResp.places.value[item.resultIndex];      
      if(placeBlock.name && placeBlock.url) {
        hasPlace = true;
        break;
      }
    }
  }
  if(!hasPlace) {
    return "";
  }
  return (
    <div className="result-block place-block">
      <Text className="result-title" id="newSearch.places" fields={{ placeQuery: query }}>Places: {query}</Text>
      <Carousel options={{wrapAround: false, pageDots: false, percentPosition: false, cellAlign: props.isRightToLeft ? 'right' : 'left', rightToLeft: props.isRightToLeft}}>
        {
          items.map(item => {
            if(item.answerType == "Places") {
              return <Place item={item} searchResp={searchResp} query={query} section={section}/>
            }
          })
        }
      </Carousel>
    </div>
  );
}
